import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  overlayShowing: false,
};

const overlaySlice = createSlice({
  name: "overlay",
  initialState,
  reducers: {
    showOverlay(state) {
      state.overlayShowing = true;
    },
    hideOverlay(_) {
      return initialState;
    },
  },
});

export const { showOverlay, hideOverlay } = overlaySlice.actions;
export default overlaySlice.reducer;
